import BaseContainer from "@/components/baseContainer";
import { API_BASE_URL } from "@/config";
import { Notice } from "@/types";
import { useEffect, useState, useMemo } from "react";
import { ClipLoader } from "react-spinners";

const NewsTable = () => {

  const [notices, setNotices] = useState<Notice[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        if (!token) throw new Error("認証情報がありません");

        const notiRes = await fetch(`${API_BASE_URL}/v1/user/notification`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!notiRes.ok) throw new Error("通知の取得に失敗しました");
        const notiData = await notiRes.json();
        setNotices(notiData);
      } catch (err) {
        console.error(err);
        setError(err instanceof Error ? err.message : "不明なエラーが発生しました");
      } finally {
        setLoading(false);
      }
    };
    
    // 本番用
    fetchData();

    // ダミーデータここから
    // 不要になったら、この行は削除ください。（コメントアウトで残されてるとソースが見づらくなるので...）
    // setNotices([
    //   { id: 1, date: '2025/10/15', message: 'BLUE SKY LIFE利用登録お申込完了' },
    //   { id: 2, date: '2025/10/15', message: 'BLUE SKY LIFE利用登録お申込完了' },
    //   { id: 3, date: '2025/10/15', message: 'BLUE SKY LIFE利用登録お申込完了' },
    //   { id: 4, date: '2025/10/15', message: 'BLUE SKY LIFE利用登録お申込完了' },
    //   { id: 5, date: '2025/10/15', message: 'BLUE SKY LIFE利用登録お申込完了' },
    //   { id: 6, date: '2025/10/15', message: 'BLUE SKY LIFE利用登録お申込完了' },
    //   { id: 7, date: '2025/10/15', message: 'BLUE SKY LIFE利用登録お申込完了' },
    // ]);
    // ダミーデータここまで

  }, []);

  const innerContent = useMemo(() => {
    if (loading) {
      return <div className="flex justify-center"><ClipLoader color="#000" loading={loading} /></div>;
    }
    if (error) {
      return <p className="text-gray-500">{error}</p>;
    }
    if (notices.length > 0) {
      return  (
        <ul className="m-news-list">
          {notices.map((n) => (
            <li key={n.id} className="">
              <em>{n.date}</em>
              <p>{n.message}</p>
            </li>
          ))}
        </ul>
        );
    }
    return <p className="text-gray-500">お知らせはありません</p>;
  }, [loading, error, notices]);

  return (
    <div>
      <BaseContainer fullWidth={true}>
        <p className="m-icon-title" style={{ 'color': 'var(--color-sea)' }}><em className="m-icon-info-rounded"></em><span>お知らせ</span></p>
        {innerContent}
      </BaseContainer>
    </div>
  );
};

export default NewsTable;